import { createSignal } from "solid-js";

/**
 * 名前・アバター編集ダイアログの開閉。
 * ヘッダーと投稿フォームの両方から開けるようにするため、ここに置いてアプリ全体で共有する。
 */
const [identityEditorOpen, setIdentityEditorOpen] = createSignal(false);

export { identityEditorOpen, setIdentityEditorOpen };
